<template>
  <div class="travel-guide-wrap">
    <template v-if="!detailItem">
    <div class="travel-guide">
      <div class="guide-block">
        <img v-for="(item, i) in guideList" :key="i" :src="item.img" alt="" class="guide-img" @click="openArticle(item, '路线')">
      </div>
      <div class="nav-icons">
        <div
          v-for="(item, index) in iconList"
          :key="index"
          class="nav-item"
          :class="{ active: selectedIcon === index }"
          @click="onTabClick(index)"
        >
          <img :src="item.img" alt="" class="nav-img">
          <span class="nav-text" :style="{ color: item.color }">{{ item.label }}</span>
          <div v-if="selectedIcon === index" class="nav-arrow" :style="{ borderBottomColor: item.color }"></div>
        </div>
      </div>
      <div v-if="selectedIcon >= 0 && selectedIcon !== 2" class="content-grid">
        <div
          v-for="(item, index) in contentList"
          :key="index"
          class="grid-item"
          @click="openArticle(item)"
        >
          <img :src="item.img" alt="" class="grid-img">
          <div class="grid-title">
            <span class="title-line" :style="{ background: currentColor }"></span>
            {{ item.title }}
          </div>
          <div class="grid-desc">{{ item.desc }}</div>
        </div>
      </div>
      <div v-if="selectedIcon >= 0 && selectedIcon !== 2 && guideTotalPages > 1" class="pagination">
        <span class="page-btn" @click="guideGoFirst">首页</span>
        <span class="page-btn" @click="guideGoPrev">上一页</span>
        <template v-for="(n, i) in guidePageNumbers" :key="i">
          <span v-if="n === '...'" class="page-ellipsis">...</span>
          <span v-else class="page-num" :class="{ active: guidePage === n }" @click="guideGoPage(n)">{{ n }}</span>
        </template>
        <span class="page-btn" @click="guideGoNext">下一页</span>
        <span class="page-btn" @click="guideGoLast">尾页</span>
        <span class="page-info">共{{ guideTotalPages }}页</span>
        <span class="page-jump">跳至<input type="text" v-model.number="guideJumpPage" class="jump-input">页<span class="jump-btn" @click="guideGoJump">确认</span></span>
      </div>
      <div v-if="selectedIcon === 2" class="location-content">
        <div class="location-desc" v-html="transportContent"></div>
      </div>
    </div>
  </template>
     <ArticleDetail v-else :article="detailItem" :breadcrumb="['旅游攻略', detailLabel || currentLabel]" :next-title="nextTitle" hide-date @go-home="$emit('go-home')" @breadcrumb-click="onBreadcrumbClick" @next-article="goNextArticle" />
  </div>
</template>

<script>
import { getArticles, getArticleDetail, getPrevNext, getMapKey } from '../api/index'
import img1 from '../assets/imgs/-h-组 35.png'
import img2 from '../assets/imgs/-h-组 36.png'
import icon1 from '../assets/imgs/1.png'
import icon2 from '../assets/imgs/2.png'
import icon3 from '../assets/imgs/3.png'
import icon4 from '../assets/imgs/4.png'
import icon5 from '../assets/imgs/5.png'
import icon6 from '../assets/imgs/6.png'
import locationImg from '../assets/imgs/location.png'
import clockImg from '../assets/imgs/clock.png'
import phoneImg from '../assets/imgs/phone.png'
import thumbImg from '../assets/imgs/ceshi.png'
import ArticleDetail from './ArticleDetail.vue'

export default {
  name: 'TravelGuide',
  props: {
    defaultArticle: { type: Object, default: null },
  },
  emits: ['go-home'],
  components: {
    ArticleDetail,
  },
  data() {
    return {
      img1,
      img2,
      locationImg,
      clockImg,
      phoneImg,
      thumbImg,
      selectedIcon: 0,
      map: null,
      detailItem: null,
      nextArticle: null,
      currentIndex: -1,
      guideList: [],
      guidePage: 1,
      guideTotal: 0,
      guidePageSize: 9,
      guideJumpPage: 1,
      detailLabel: '',
      iconList: [
        { img: icon1, label: '美食', color: '#E74A08' },
        { img: icon2, label: '住宿', color: '#1A94D3' },
        { img: icon3, label: '交通', color: '#3BAC74' },
        { img: icon4, label: '景点', color: '#16A39E' },
        { img: icon5, label: '购物', color: '#DB7625' },
        { img: icon6, label: '体验', color: '#16A39E' },
      ],
      allContents: [[], [], [], [], [], [], []],
      transportContent: '',
    }
  },
  computed: {
    contentList() {
      return this.allContents[this.selectedIcon] || []
    },
    currentColor() {
      const item = this.iconList[this.selectedIcon]
      return item ? item.color : '#000'
    },
    currentLabel() {
      const item = this.iconList[this.selectedIcon]
      return item ? item.label : ''
    },
    nextTitle() {
      return this.nextArticle ? this.nextArticle.title : ''
    },
    guideTotalPages() {
      return Math.max(1, Math.ceil(this.guideTotal / this.guidePageSize))
    },
    guidePageNumbers() {
      const total = this.guideTotalPages
      const cur = this.guidePage
      if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
      const pages = [1, 2]
      if (cur > 3) pages.push('...')
      if (cur > 2 && cur < total - 1) pages.push(cur)
      if (cur < total - 2) pages.push('...')
      pages.push(total - 1, total)
      return [...new Set(pages)]
    },
  },
  watch: {
    detailItem(val) { if (val) this.$nextTick(() => { window.scrollTo(0, 0) }) },
    selectedIcon() {
      this.detailItem = null
      this.currentIndex = -1
      this.guidePage = 1
      this.fetchGuideData()
    },
    '$route.query.guideArticle': {
      handler(val) {
        if (!val) { this.detailItem = null; this.detailLabel = '' }
      },
    },
    '$route.query.guideTab': {
      handler(val) {
        const idx = parseInt(val)
        if (!isNaN(idx) && idx !== this.selectedIcon) this.selectedIcon = idx
      },
    },
  },
  mounted() {
    const qt = parseInt(this.$route.query.guideTab)
    if (!isNaN(qt)) this.selectedIcon = qt
    const gl = this.$route.query.guideLabel
    if (gl) this.detailLabel = gl
    if (this.defaultArticle) {
      this.detailLabel = this.$route.query.guideLabel || this.detailLabel || ''
      this.openArticle(this.defaultArticle, this.detailLabel)
    }
    this.fetchGuideData()
    this.fetchGuideRoutes()
  },
  methods: {
    async fetchGuideRoutes() {
      try {
        const res = await getArticles({ category: 'travel_routes', lang: 'zh', pageNum: 1, pageSize: 2 })
        const items = res.rows || []
        this.guideList = items.map(item => ({
          id: item.id,
          img: item.coverImage || thumbImg,
          title: item.title,
          desc: item.summary || '',
          date: (item.publishTime || '').substring(0, 10),
        }))
      } catch (e) {
        console.error('获取推荐路线失败:', e)
      }
    },
    async fetchGuideData() {
      const categoryMap = ['travel_food', 'travel_accommodation', 'travel_transport', 'travel_activities', 'travel_specialties', 'travel_entertainment']
      const category = categoryMap[this.selectedIcon]
      if (!category) return
      try {
        const res = await getArticles({ category, lang: 'zh', pageNum: this.guidePage, pageSize: this.guidePageSize })
        this.guideTotal = res.total || 0
        const rows = res.rows || []
        const imgIcons = [icon1, icon2, icon3, icon4, icon5, icon6]
        const iconImg = imgIcons[this.selectedIcon] || icon1
        const list = rows.map(item => ({
          id: item.id,
          img: item.coverImage || iconImg,
          title: item.title,
          desc: item.summary || '',
          date: (item.publishTime || '').substring(0, 10),
        }))
        this.allContents.splice(this.selectedIcon, 1, list)
        if (this.selectedIcon === 2 && rows.length) {
          const detailRes = await getArticleDetail(rows[0].id)
          if (detailRes.code === 200 && detailRes.data) {
            this.transportContent = (detailRes.data.content || '').replace(/<\/?p>/g, '')
          }
        }
      } catch (e) {
        console.error('获取攻略数据失败:', e)
      }
    },
    async openArticle(item, label) {
      this.detailLabel = label || ''
      this.detailItem = { ...item }
      this.nextArticle = null
      this.currentIndex = this.contentList.indexOf(item)
      if (label === '路线') {
        this.$router.push({ query: { menu: this.$route.query.menu || 4, guideArticle: item.id, guideLabel: '路线' } }).catch(() => {})
      } else {
        this.$router.push({ query: { ...this.$route.query, menu: 4, guideArticle: item.id } }).catch(() => {})
      }
      if (item.id) {
        try {
          const res = await getArticleDetail(item.id)
          if (res.code === 200 && res.data) {
            this.detailItem = { ...item, ...res.data }
            const pn = await getPrevNext(item.id, { category: res.data.category, lang: res.data.lang || 'zh' })
            if (pn.code === 200 && pn.data) this.nextArticle = pn.data.next
          }
        } catch (e) {
          console.error('获取文章详情失败:', e)
        }
      }
    },
    onTabClick(index) {
      this.selectedIcon = index
      const q = { ...this.$route.query, guideTab: index }
      delete q.guideArticle
      this.$router.replace({ query: q }).catch(() => {})
    },
    onBreadcrumbClick() {
      this.detailItem = null
      this.detailLabel = ''
      const q = { ...this.$route.query }
      delete q.guideArticle
      delete q.guideLabel
      this.$router.replace({ query: q }).catch(() => {})
    },
    goNextArticle() {
      if (this.nextArticle) {
        const next = this.nextArticle
        this.openArticle({ id: next.id, title: next.title })
      }
    },
    guideGoPage(n) { if (this.guidePage !== n) { this.guidePage = n; this.fetchGuideData() } },
    guideGoFirst() { if (this.guidePage !== 1) { this.guidePage = 1; this.fetchGuideData() } },
    guideGoPrev() { if (this.guidePage > 1) { this.guidePage--; this.fetchGuideData() } },
    guideGoNext() { if (this.guidePage < this.guideTotalPages) { this.guidePage++; this.fetchGuideData() } },
    guideGoLast() { if (this.guidePage !== this.guideTotalPages) { this.guidePage = this.guideTotalPages; this.fetchGuideData() } },
    guideGoJump() {
      const n = Number(this.guideJumpPage)
      if (n >= 1 && n <= this.guideTotalPages && n !== this.guidePage) { this.guidePage = n; this.fetchGuideData() }
    },
    async initMap() {
      if (this.map) return
      try {
        const keyRes = await getMapKey()
        const KEY = (keyRes.code === 200 && keyRes.msg) ? keyRes.msg : ''
        if (!KEY) return
        const loadQQMap = () => {
          this.$nextTick(() => {
            const el = document.getElementById('hgsMap')
            if (!el || el.innerHTML) return
            const center = new window.TMap.LatLng(34.632, 119.283)
            this.map = new window.TMap.Map(el, { center, zoom: 14 })
            new window.TMap.MultiMarker({
              map: this.map,
              geometries: [{ id: 'hgs', position: center }],
            })
          })
        }
        if (window.TMap) { loadQQMap(); return }
        const script = document.createElement('script')
        script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${KEY}`
        script.onload = () => setTimeout(loadQQMap, 300)
        document.head.appendChild(script)
      } catch (e) {
        console.error('地图加载失败:', e)
      }
    },
  },
}
</script>

<style scoped lang="less">
.travel-guide-wrap{
  .travel-guide{
  .guide-block{
    display: flex;
    padding: 0.3rem 0;
    gap: 0.2rem;
    .guide-img{
      width: 7.23rem;
      height: 3.78rem;
    }
  }
  .nav-icons{
    display: flex;
    justify-content: center;
    gap: 0.3rem;
    padding: 0.3rem 0;
    background: url('../assets/imgs/图层 1054.png') no-repeat center / cover;
    .nav-item{
      position: relative;
      cursor: pointer;
      .nav-img{
        width: 2rem;
        height: 2.16rem;
        display: block;
      }
      .nav-text{
        position: absolute;
        left: 50%;
        bottom: 0.2rem;
        transform: translateX(-50%);
        font-size: 0.29rem;
        white-space: nowrap;
      }
      .nav-arrow{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 0.08rem solid transparent;
        border-right: 0.08rem solid transparent;
        border-bottom: 0.1rem solid;
      }
    }
  }
  .content-grid{
    display: flex;
    flex-wrap: wrap;
    padding: 0.3rem 0.6rem;
    gap: 0.2rem;
    .grid-item{
      width: calc((100% - 0.4rem) / 3);
      border: 1px solid #eee;
      padding: 0.15rem;
      box-sizing: border-box;
      cursor: pointer;
      .grid-img{
        width: 100%;
        height: 2.4rem;
        object-fit: cover;
        display: block;
      }
      .grid-title{
        font-size: 0.2rem;
        color: #000;
        margin-top: 0.1rem;
        display: flex;
        align-items: center;
        .title-line{
          display: inline-block;
          width: 0.04rem;
          height: 0.2rem;
          margin-right: 0.08rem;
          flex-shrink: 0;
        }
      }
      .grid-desc{
        font-size: 0.16rem;
        color: #666;
        margin-top: 0.05rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .pagination{
    display: flex; align-items: center; justify-content: center; gap: 0.08rem; margin-top: 0.3rem; flex-wrap: wrap;
    .page-btn, .page-num{
      padding: 0.08rem 0.15rem; border: 1px solid #ddd; border-radius: 0.04rem; font-size: 0.18rem; color: #333; cursor: pointer;
      &:hover{ background: #369BF8; color: #fff; border-color: #369BF8; }
    }
    .page-num.active{ background: #369BF8; color: #fff; border-color: #369BF8; }
    .page-ellipsis{ padding: 0.08rem 0.05rem; font-size: 0.18rem; color: #666; }
    .page-info{ font-size: 0.16rem; color: #999; margin-left: 0.1rem; }
    .page-jump{
      font-size: 0.16rem; color: #666;
      .jump-input{ width: 0.5rem; height: 0.32rem; border: 1px solid #ccc; border-radius: 0.04rem; text-align: center; margin: 0 0.05rem; outline: none; }
      .jump-btn{ padding: 0.04rem 0.1rem; border: 1px solid #ddd; border-radius: 0.04rem; cursor: pointer; &:hover{ background: #369BF8; color: #fff; } }
    }
  }
  .location-content{
    padding: 0.3rem 0rem;
    ::v-deep img{ width: 100% !important; }
    .location-title{
      font-size: 0.28rem;
      color: #000;
      font-weight: bold;
      text-align: center;
      margin-bottom: 0.2rem;
    }
    .location-desc{
      font-size: 0.2rem;
      color: #333;
      line-height: 1.8;
      margin-bottom: 0.3rem;
    }
    .location-info{
      display: flex;
      justify-content: center;
      gap: 0.6rem;
      .info-item{
        display: flex;
        align-items: center;
        margin-bottom: 0.15rem;
        font-size: 0.2rem;
        color: #333;
        .info-icon{
          width: 0.3rem;
          height: auto;
          margin-right: 0.15rem;
          flex-shrink: 0;
        }
      }
    }
    .map-wrap{
      width: 100%;
      margin-top: 0.3rem;
      .map-img{
        width: 100%;
        height: 6rem;
        border-radius: 0.1rem;
        display: block;
      }
      .map-label{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, calc(-50% - 0.6rem));
        background: #fff;
        color: #000;
        font-size: 0.2rem;
        padding: 0.06rem 0.25rem;
        border-radius: 0.06rem;
        box-shadow: 0 0.02rem 0.08rem rgba(0,0,0,0.2);
        white-space: nowrap;
      }
    }
  }
}
}
</style>
